import styled from "styled-components";

export const LoadingOverlay = styled.div`
  position: absolute;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const ResultBox = styled.div`
  border: 1px solid #a5d892;
  border-radius: 5px;
  boxshadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  padding: 15px;
  whitespace: pre-wrap;
  wordbreak: break-word;
`;

export const SuccessBox = styled(ResultBox)`
  background-color: #e3ffd8;
  border-color: A5D892;
`;

export const ErrorBox = styled(ResultBox)`
  background-color: #ffd8d8;
  border-color: #d89292;
`;
